export const routes = {
  login: '/login',
  signup: '/signup',
  forgotPassword: '/forgot-password',
  forgotPasswordVerification: '/forgot-password/verification',
  resetPassword: '/reset-password',
  emailVerification: '/email-verification',
  onboarding: '/onboarding',
  onboardingChat: '/onboarding/chat', // Conversational onboarding
  onboardingSummary: '/onboarding/summary',
  onboardingAISummary: '/onboarding/ai-summary',
  onboardingMatches: '/onboarding/matches',
  home: '/dashboard',
  // V1.5.M10 B-P2 white-label OAuth relay (cross-subdomain Google sign-in)
  oauthLaunch: '/oauth/launch', // canonical-origin interstitial that runs Google
  oauthRelay: '/oauth/relay', // subdomain page that redeems the handback code
  // Magic-link landing for connection-notification email buttons
  connect: '/connect',
  chat: '/chat',
  agentReview: '/agent-review',
  matches: '/matches',
  profile: '/profile',
  settings: '/settings',
  // Phase 3.3: Interactive Search/Browse
  discover: '/discover',
  // Admin Dashboard
  adminHealth: '/admin/health',
  adminMatching: '/admin/matching',
};
